import { Component, inject } from '@angular/core';
import { PromoCardComponent } from "../../elements/promo-card/promo-card.component";
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginRequestBody } from '../../../models/login/login-request-body';
import { AuthApiService } from '../../../services/auth-api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType, ToastPosition } from '../../../../../notifications/models/toast-notification-type';
import { DynamicRouterService } from '../../../../../shared/services/dynamic-router.service';
import { ApiErrorService } from '../../../../../shared/services/api-error.service';
import { LanguageService, SupportedLanguage } from '../../../../../shared/services/translations/language.service';

@Component({
  selector: 'app-login',
  imports: [CommonModule, PromoCardComponent, RouterLink, FormsModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  authService = inject(AuthService);
  authApiService = inject(AuthApiService);
  apiErrorService = inject(ApiErrorService);
  toastNotificationService = inject(ToastNotificationService);
  router = inject(Router);
  dynamicRouterService = inject(DynamicRouterService);
  translate = inject(TranslateService);
  languageService = inject(LanguageService);
  isLanguageOpen = false;

  showPassword = false;
  disableButton = false;
  loading = false;

  toggleLanguageDropdown() {
    this.isLanguageOpen = !this.isLanguageOpen;
  }

  changeLanguage(lang: SupportedLanguage) {
    this.languageService.changeLanguage(lang);
    this.isLanguageOpen = false;
  }

  get isRTL(): boolean {
    return this.languageService.currentLang() === 'ar';
  }

  submit(form: NgForm) {

    form.value.remember == '' ? form.value.remember = false : form.value.remember = form.value.remember;
    this.loading = true;
    this.disableButton = true;

    let requestBody: LoginRequestBody = {
      identifier: form.value.email,
      password: form.value.password,
    };

    this.authApiService.login(requestBody).subscribe({
      next: (response) => {
        this.authService.saveAccessToken(response.access);

        const tokenData = this.authService.getTokenData();
        if (tokenData?.role === 'customer') {
          localStorage.removeItem('access');
          this.loading = false;
          this.disableButton = false;
          this.toastNotificationService.createNotification(
            this.translate.instant('auth.login.not_allowed'),
            ToastNotificationType.ERROR,
            this.translate.instant('auth.login.toast_error_title'),
            ToastPosition.TOP_RIGHT
          );

          return;
        }

        this.disableButton = false;
        this.authService.saveRefreshToken(response.refresh);
        this.dynamicRouterService.updateRoutesBasedOnRole();
        this.toastNotificationService.createNotification(this.translate.instant('auth.login.toast_success_message'), ToastNotificationType.SUCCESS, this.translate.instant('auth.login.toast_success_title'), ToastPosition.TOP_RIGHT);
        this.loading = false;
        this.router.navigate(['/']);
      },
      error: (err: HttpErrorResponse) => {
        this.disableButton = false;
        this.loading = false;
        this.toastNotificationService.createNotification(this.apiErrorService.getDisplayMessage(err, this.translate.instant('auth.login.toast_error_message')), ToastNotificationType.ERROR, this.translate.instant('auth.login.toast_error_title'), ToastPosition.TOP_RIGHT);
      },
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
}


